<div class="agency-users-grid">
  <form [formGroup]="usersForm">
    @if (agencyId() === null) {
      <lib-form-dropdown
        class="flex justify-self-center w-4/6"
        label="Agency"
        formControlName="agencyId"
        [options]="lookupStore.agencies() || []">
      </lib-form-dropdown>
    }
    <div formArrayName="users" class="w-full">
      <div *ngFor="let user of usersFormArray.controls; let i = index" [formGroupName]="i" class="flex gap-[35px]">
        <div class="w-full lg:w-1/5">
          <lib-form-text
            label="First Name"
            formControlName="firstName">
          </lib-form-text>
        </div>
        <div class="w-full lg:w-1/5">
          <lib-form-text
            label="Last Name"
            formControlName="lastName">
          </lib-form-text>
        </div>
        <div class="w-full lg:w-1/5">
          <lib-form-text
            label="Email"
            formControlName="email">
          </lib-form-text>
        </div>
        <div class="w-full lg:w-1/5">
            <lib-form-phone
              label="Direct Phone"
              formControlName="phone">
            </lib-form-phone>
        </div>
        <div class="w-full lg:w-1/5">
          <lib-form-dropdown
              label="Role"
              formControlName="role"
              [options]="roles() || []">
            </lib-form-dropdown>
        </div>
      </div>
      <div class="text-left mt-4">
        <lib-button [cssType]="'btn-link'"  [text]="'Add Another User'" [icon]="'circleplus'" [buttonType]="'button'" (click)="addUser()"></lib-button>
      </div>
    </div>
  </form>

</div>